import { BaseContainer } from "../../shared/containers/BaseContainer/BaseContainer";

const ImpersonationWrapper = ({ children }: React.PropsWithChildren) => (
  <BaseContainer>{children}</BaseContainer>
);

export { ImpersonationWrapper };
